export default __webpack_public_path__ + "static/media/datebox.bc8622a6.png";